import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import keep from './keep'
import cart from './cart'
import illegal from './illegal'
import fee from './fee'
import scooter from './scooter'
import money from './money'

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        keep,
        cart,
        illegal,
        fee,
        scooter,
        money
    }
})